import { render, staticRenderFns } from "./SelectAdmins.vue?vue&type=template&id=aa7bf6c2&"
import script from "./SelectAdmins.vue?vue&type=script&lang=js&"
export * from "./SelectAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports